'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import moment from 'moment'


var ChatTyping = function (_Component) {
    _inherits(ChatTyping, _Component);

    function ChatTyping(props) {
        _classCallCheck(this, ChatTyping);

        var _this = _possibleConstructorReturn(this, (ChatTyping.__proto__ || Object.getPrototypeOf(ChatTyping)).call(this, props));

        _this.state = {
            visibilityStatus: true
        };
        _this.timer = null;
        _this.setTypingTimer = _this.setTypingTimer.bind(_this);
        _this.clearTimeoutFunc = _this.clearTimeoutFunc.bind(_this);
        return _this;
    }

    _createClass(ChatTyping, [{
        key: 'setTypingTimer',
        value: function setTypingTimer() {
            if (this.timer !== null) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                this.setState({ visibilityStatus: false });
                this.props.setTypingMessage({ sender_id: this.props.user.id, message: '' });
            }.bind(this), 3000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timer !== null) {
                clearTimeout(this.timer);
                // this.props.setTypingMessage({ sender_id: this.props.user.id, message: '' })
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            console.log("next props", nextProps.typingMessage.message);
            if (!nextProps.typingMessage.message) {
                this.clearTimeoutFunc();
            }
        }
    }, {
        key: 'clearTimeoutFunc',
        value: function clearTimeoutFunc() {
            console.log("Clear Timeout Call");
            if (this.timer !== null) {
                clearTimeout(this.timer);
            }
            this.setState({
                visibilityStatus: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var typingcomp = void 0;
            console.log("typing object", JSON.stringify(this.props.typingMessage));
            console.log("User object", JSON.stringify(this.props.user));
            if (this.props.typingMessage.message) {
                typingcomp = this.state.visibilityStatus ? _react2.default.createElement(ChatTypingComponent, {
                    typingMessage: this.props.typingMessage,
                    setTypingTimer: this.setTypingTimer,
                    user: this.props.user,
                    user_type: this.props.user_type,
                    mask_user_typing_text: this.props.mask_user_typing_text }) : null;
            }
            return _react2.default.createElement(
                'div',
                null,
                typingcomp
            );
        }
    }]);

    return ChatTyping;
}(_react.Component);

ChatTyping.defaultProps = {
    typingMessage: { message: '' }
};

var ChatTypingComponent = function ChatTypingComponent(_ref) {
    var typingMessage = _ref.typingMessage,
        setTypingTimer = _ref.setTypingTimer,
        user = _ref.user,
        user_type = _ref.user_type,
        mask_user_typing_text = _ref.mask_user_typing_text;

    setTypingTimer();
    var typingPersonName = '',
        imageURL = '';
    if (!user) {
        return null;
    }

    if (mask_user_typing_text) {
        typingPersonName = mask_user_typing_text ? Constants.DEFAULT_AGENT_NAME : Constants.DEFAULT_GUEST_NAME;
    } else {
        typingPersonName = user.name;
    }

    imageURL = user.pic;

    if (!mask_user_typing_text) {
        return _react2.default.createElement(
            'div',
            { className: 'row msg_container base_receive' },
            _react2.default.createElement(
                'div',
                { className: 'col-md-2 no-padding col-xs-2 imgContainer' },
                _react2.default.createElement('img', { className: 'profile-img img-responsive', src: imageURL, alt: 'agent_typing' })
            ),
            _react2.default.createElement(
                'div',
                { className: 'col-xs-10 col-md-10 no-padding' },
                _react2.default.createElement(
                    'div',
                    { className: 'messages msg_receive' },
                    _react2.default.createElement(
                        'p',
                        { className: 'message' },
                        typingMessage.message,
                        _react2.default.createElement(
                            'span',
                            { className: 'agent_message_typing' },
                            _react2.default.createElement('span', { className: 'icons icon1' }),
                            _react2.default.createElement('span', { className: 'icons icon2' }),
                            _react2.default.createElement('span', { className: 'icons icon3' })
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        null,
                        typingPersonName
                    )
                )
            )
        );
    } else {
        return _react2.default.createElement(
            'div',
            { className: 'row msg_container base_receive' },
            _react2.default.createElement(
                'div',
                { className: 'col-md-2 no-padding col-xs-2 imgContainer' },
                _react2.default.createElement('img', { className: 'profile-img img-responsive', src: imageURL, alt: 'userImage' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'label label-default' },
                    typingPersonName
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'col-xs-10 col-md-10 no-padding' },
                _react2.default.createElement(
                    'div',
                    { className: 'messages message_typing' },
                    _react2.default.createElement('span', { className: 'icons icon1' }),
                    _react2.default.createElement('span', { className: 'icons icon2' }),
                    _react2.default.createElement('span', { className: 'icons icon3' })
                )
            )
        );
    }
};

exports.default = ChatTyping;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatTyping.js